import React, { Component } from 'react'
import { Card, Button, Row, Col, Modal, ModalHeader, ModalBody, Form, Input } from 'reactstrap'
import Fetch from '../../Auxiliares/fetch'
import verImg from '../../Img/openDoc.png'
import { toast } from 'react-toastify'
import {ip} from '../../Auxiliares/ip'

export default class pendienteCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isViewOpen: null,
            isDenegateOpen: false,
            disable: false,
            notificarModal_noControl: '',
            notificarModal_documento: '',
            mensaje: 'Documento invalido, favor de acercarse a las oficinas de servicios escolares'
        }
        this.toggleView = this.toggleView.bind(this)
        this.toggleDenegate = this.toggleDenegate.bind(this)
        this.toggleButton = this.toggleButton.bind(this)
        this.enviar = this.enviar.bind(this)
        this.notificarCorreo = this.notificarCorreo.bind(this)
    }


    toggleView(obj) {
        this.setState(prevState => ({
            isViewOpen: obj ? obj : null
        })
        )
    }

    toggleButton(){
        this.setState(prevState => ({
            disable: !prevState.disable
        })
        )
    }

    toggleDenegate() {
        this.setState(prevState => ({
            isDenegateOpen: !prevState.isDenegateOpen
        })
        )
    }

    setValue(field, ev) {
        this.setState({ [field]: ev.target.value })
    }

    aceptar = (id) => {
        Fetch('/api/aceptarDocumento', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id })
        })
            .then(response => {
                this.props.actualizarLista();
                this.toggleView()
            })
            .catch(err => {
                switch (err.status) {

                    case 600:
                        console.log('Error inesperado')
                        break;

                    case 602:
                        console.log('Este usuario no existe')
                        break;

                    default:
                        toast.error('Error al aceptar')
                        break;
                }
            })
    }

    denegar = (id) => {
        Fetch('/api/deleteDocumento', {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id })
        })
        .then(response => {
            this.toggleView()
            this.setState({ notificarModal_noControl: this.props.noControl, notificarModal_documento: this.props.documento })
            this.toggleDenegate()
        })
        .catch(err => {
            switch (err.status) {

                case 600:
                    console.log('Error inesperado')
                    break;

                case 602:
                    console.log('Este usuario no existe')
                    break;

                default:
                    break;
                }
        })
    }

    enviar(e){
        e.preventDefault();
        this.toggleButton();
        this.notificarCorreo();
    }
    notificarCorreo(){
        const { noControl, documento } = this.props
        const { mensaje } = this.state    

        Fetch('/api/notificarCorreoEstudiante', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ noControl, documento, mensaje })
        })
        .then(response => {
            this.props.actualizarLista();
            this.toggleDenegate();
        })
        .catch(err => {
            switch (err.status) {

                case 600:
                console.log('Error inesperado')
                break;
                
                case 602:
                console.log('Este usuario no existe')
                break;

                default:
                toast.error('Algo salio mal')
                break;
                }
            }) 
    }

    dateToString() {
        var date = new Date(this.props.fechaRegistro);
        return date.toLocaleDateString() + " " + date.toLocaleTimeString();
    }

    render() {
        return (
            <div className="col-12">
                <Card className={this.props.encabezado ? "mb-1 col-12 py-2 bg-secondary text-white" : "mb-1 col-12 py-2"}>
                    <Row className="p-1 col-12 mx-1">
                        <Col sm="2"><div className={this.props.encabezado ? "font-weight-bold text-center" : "text-left"}></div>{this.props.encabezado ? "No.Control" : this.props.noControl}</Col>
                        <Col sm="4"><div className={this.props.encabezado ? "font-weight-bold text-center" : "text-left"}></div>{this.props.encabezado ? "Documento" : this.props.documento}</Col>
                        <Col sm="3"><div className={this.props.encabezado ? "font-weight-bold text-center" : "text-left"}></div>{this.props.encabezado ? "Fecha de registro" : this.dateToString()}</Col>
                        <Col sm="2"><div className={this.props.encabezado ? "font-weight-bold text-center" : "text-left"}></div>{this.props.encabezado ? "Registrado por" : this.props.registradoPor}</Col>
                        <Col>{this.props.encabezado ? <div /> : <img className="img-responsive clicable" width="50%" alt="icono ver" src={verImg} onClick={() => this.toggleView(this.props)} />}</Col>
                    </Row>
                </Card>

                <Modal className="pt-5 modal-xl" isOpen={this.state.isViewOpen !== null} toggle={() => this.toggleView()}>
                    <ModalHeader toggle={() => this.toggleView()} className="font-weight-bold">{this.props.documento}</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Card className="border-0">
                                    <Row>
                                        <Col className="text-center">
                                            <iframe
                                                title="PDF viewer"
                                                width="100%" 
                                                height="625"
                                                src={ip+this.props.ubicacion}>
                                            </iframe>
                                        </Col>
                                    </Row>

                                    <Row className=" text-center">
                                        <Col>
                                            <Button className="btn-success w-100" onClick={() => this.aceptar(this.props.id)}>Confirmar</Button>
                                        </Col>
                                        <Col>
                                            <Button className="btn-secondary w-100" onClick={() => this.denegar(this.props.id)}>Eliminar</Button>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>

                <Modal className="pt-5" isOpen={this.state.isDenegateOpen} >
                    <ModalHeader className="font-weight-bold">Notificacion por correo</ModalHeader>
                    <ModalBody>
                       <Card className="border-0">
                           <Form onSubmit={this.notificarCorreo}>
                                    <Row>
                                        <Col className="col-4">
                                            <Input type="text" name="noControl" disabled value={this.state.notificarModal_noControl} className="w-100"/>
                                        </Col>

                                        <Col>
                                            <Input type="text" name="documento" disabled value={this.state.notificarModal_documento} className="w-100"/>
                                        </Col>
                                    </Row>

                                <Row className="mt-3 text-center">
                                   <Col>
                                        <Input type="textarea" name="mensaje" className="h-100 w-100" defaultValue={this.state.mensaje} onChange={this.setValue.bind(this,"notificarModal_mensaje")}/>
                                   </Col>
                                </Row>                                
                                
                                <Row className="text-center px-3">
                                    <Button name="notificar" value="Enviar" className="w-100 mt-2 bg-info text-light" disabled={this.state.disable} onClick={this.enviar}>Enviar</Button>
                                </Row>
                           </Form>
                       </Card>
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}
